import axios from 'axios'
// import {MessageBox,Message} from 'element-ui'

const service = axios.create({
  baseURL: 'http://36.7.190.65:5001',
  withCredentials: true,
  timeout: 5000
})
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => { //请求成功
    if (response.status == 200) {
      const data = response
      return data
    }
  },
  error => { //请求时失败
    // console.log(11, error)
    return Promise.reject(error)
  }
)

export default service
